/** Shared helpers for view visibility and nav state updates. */
import { focusViewHeading } from './a11y';

export function hideAllViews(): void {
  document.querySelectorAll('.view').forEach((view) => {
    view.classList.add('hidden');
    (view as HTMLElement).style.display = 'none';
  });
}

export function showView(viewId: string): void {
  const viewElement = document.getElementById(`view-${viewId}`);
  if (!viewElement) return;
  viewElement.classList.remove('hidden');
  viewElement.style.display = '';
  focusViewHeading(viewId);
}

export function setActiveNavLink(view: string): void {
  document.querySelectorAll('.nav-link, .nav-link-mobile').forEach((link) => {
    link.classList.toggle('active', link.getAttribute('data-view') === view);
  });
}
